import BOSFilterMultiselect from 'Components/Generic/BOSMultiselect/BOSFilterMultiselect';
import ResourceDrawerButton from 'Components/SiteDrawerContainer/ResourceDrawerButton';
import ResourceData from 'Data/ResourceData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

let DM = new DataManager();
const ResourceMultiselect = ({
  labelText = '',
  orgId,
  onSelectedResourcesUpdate = () => {},
  initialSelectedItems,
  ...props
}) => {
  const [resourceList, setResourceList] = useState([]);
  const [selectedResources, setSelectedResources] = useState([]);

  useEffect(() => {
    DM.add(
      ResourceData.registerListener(
        'RES_LIST_FOR_CORE_LOADED',
        onResourceListLoaded,
      ),
      ResourceData,
    );
    DM.add(
      ResourceData.registerListener('ALL_RECORDS_LOADED', onResourceListLoaded),
      ResourceData,
    );
    DM.add(
      ResourceData.registerListener(
        'RECORDS_LOAD_ERROR',
        onResourceListLoadError,
      ),
      ResourceData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    if (orgId) {
      ResourceData.getResourcesForOrg(orgId);
    } else {
      ResourceData.getAllResources();
    }
  }, [orgId]);

  useEffect(() => {
    onSelectedResourcesUpdate && onSelectedResourcesUpdate(selectedResources);
  }, [selectedResources]);

  const onResourceListLoaded = (payload) => {
    if (payload) {
      setResourceList(payload.records);
    }
  };

  const onResourceListLoadError = () => {};
  const onSelectionChange = (resources) => {
    setSelectedResources(resources);
  };

  return (
    <BOSFilterMultiselect
      labelText={labelText}
      tooltipField={'description'}
      listData={resourceList}
      onSelectionUpdate={onSelectionChange}
      placeholder='Select Resource(s)...'
      defaultSelectedItems={initialSelectedItems}
      labelRenderer={(resource) => {
        return <ResourceDrawerButton resource={resource} />;
      }}
      {...props}
    />
  );
};

ResourceMultiselect.propTypes = {
  labelText: PropTypes.string,
  orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelectedResourcesUpdate: PropTypes.func,
  initialSelectedItems: PropTypes.array,
};

export default ResourceMultiselect;
